// User toggle notified by SMS
document.addEventListener('DOMContentLoaded', () => {
  const notifiedBySMSHint = document.querySelector('#user_companies_user_attributes_notified_by_sms_input .inline-hints')
  const notifiedBySMSInput = document.querySelector('#user_companies_user_attributes_notified_by_sms')
  const userPhoneNumberInput = document.querySelector('#user_phone_number')

  if (!notifiedBySMSHint || !notifiedBySMSInput || !userPhoneNumberInput) return

  let userPhoneNumber = userPhoneNumberInput.value

  function toggleNotifiedBySMSInput() {
    if (userPhoneNumber !== '') {
      notifiedBySMSInput.disabled = false
      notifiedBySMSHint.style.display = 'none'
    } else {
      notifiedBySMSInput.disabled = true
      notifiedBySMSInput.checked = false
      notifiedBySMSHint.style.display = ''
    }
  }

  toggleNotifiedBySMSInput()

  userPhoneNumberInput.addEventListener('keyup', (e) => {
    userPhoneNumber = e.target.value
    toggleNotifiedBySMSInput()
  })
})

